import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { ICRUDOptions } from '@phx-erp/shared';
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { DELETE_BANK_ACCOUNT, GET_BANK_ACCOUNT, GET_BANK_ACCOUNTS, SAVE_BANK_ACCOUNT } from "../../../data/definitions/bank-account.definition";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DataService } from "../../../data/services/data.service";
import { BankAccount, BankAccountInput, DeleteBankAccountMutation, DeleteBankAccountMutationVariables, DeletionResponse, GetBankAccountQuery, GetBankAccountQueryVariables, GetBankAccountsQuery, GetBankAccountsQueryVariables, SaveBankAccountMutation, SaveBankAccountMutationVariables, SearchInput } from "../../../generated/generated-types";

@Injectable({
  providedIn: 'root'
})
export class BankAccountService extends BaseListService<BankAccount> {

  constructor(private dataService: DataService,
    private baseDataService: BaseDataService,
    private systemService: SystemService) {
    super();
  }
  //#region implementation
  getItems(searchInput?: SearchInput, o?: ICRUDOptions) {

    let fragment = GET_BANK_ACCOUNTS;

    if (o?.currentColumnConfig) {
      this.onlyKeepSelectedGraphQLNodesNew(fragment, o.currentColumnConfig.baseView, o.currentColumnConfig.columns);
    }

    return this.baseDataService.query<GetBankAccountsQuery, GetBankAccountsQueryVariables>(
      fragment, {
      input: searchInput as any
    });
  }

  getItem(id: string) {

    return this.baseDataService.query<GetBankAccountQuery, GetBankAccountQueryVariables>(
      GET_BANK_ACCOUNT, {
      id: id
    });
  }

  getItemStream(id: string) {
    return this.getItem(id).mapStream(x => x.getBankAccount);
  }

  async getItemData(id: string): Promise<BankAccount> {
    let l = await lastValueFrom(this.getItem(id).single$);
    return l.getBankAccount as BankAccount;
  }

  async deleteItem(id: string): Promise<DeletionResponse> {
    let res = await lastValueFrom(this.baseDataService.mutate<DeleteBankAccountMutation, DeleteBankAccountMutationVariables>(
      DELETE_BANK_ACCOUNT, {
      id: id
    }));

    return res.deleteBankAccount
  }

  async saveItem(bankAccount: BankAccount | BankAccountInput): Promise<BankAccount> {

    let validated = await this.systemService.validateObject<BankAccountInput>(bankAccount, "BankAccountInput");

    let saved = await lastValueFrom(this.baseDataService.mutate<SaveBankAccountMutation, SaveBankAccountMutationVariables>(
      SAVE_BANK_ACCOUNT, {
      input: validated
    }));

    return saved.saveBankAccount as BankAccount;
  }
  //#endregion

}
